<template>
  <b-modal
    :id="'confirmation'+type"
    :ref="'confirmation'+type"
    centered
    ok-title="Save"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    size="lg"
    hide-footer
    hide-header
  >
    <b-overlay
      id="overlay-background"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <div
        class="p-2 text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          class="mb-2"
          viewBox="0 0 80 80"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.3335 39.9999C3.3335 60.3332 19.6668 76.6666 40.0002 76.6666C60.3335 76.6666 76.6668 60.3332 76.6668 39.9999C76.6668 19.6666 60.3335 3.33325 40.0002 3.33325C19.6668 3.33325 3.3335 19.6666 3.3335 39.9999ZM10.0002 39.9999C10.0002 23.3333 23.3335 9.99992 40.0002 9.99992C56.6668 9.99992 70.0002 23.3333 70.0002 39.9999C70.0002 56.6666 56.6668 69.9999 40.0002 69.9999C23.3335 69.9999 10.0002 56.6666 10.0002 39.9999ZM43.3335 39.9999V26.6666C43.3335 24.6666 42.0002 23.3333 40.0002 23.3333C38.0002 23.3333 36.6668 24.6666 36.6668 26.6666V39.9999C36.6668 41.9999 38.0002 43.3333 40.0002 43.3333C42.0002 43.3333 43.3335 41.9999 43.3335 39.9999ZM43.0002 54.6666C43.0002 54.9999 42.6668 55.3333 42.3335 55.6666C41.6668 56.3333 41.0002 56.6666 39.6668 56.6666C38.6668 56.6666 38.0002 56.3333 37.3335 55.6666C36.6668 54.9999 36.3335 54.3333 36.3335 53.3333C36.3335 52.9427 36.4479 52.6666 36.5426 52.4378C36.6096 52.2761 36.6668 52.138 36.6668 51.9999C36.6668 51.6666 37.0002 51.3333 37.3335 50.9999C38.3335 49.9999 39.6668 49.6666 41.0002 50.3333C41.1668 50.3333 41.2502 50.4166 41.3335 50.4999C41.4168 50.5832 41.5002 50.6666 41.6668 50.6666C42.0002 50.6666 42.3335 50.9999 42.3335 50.9999C42.5002 51.1666 42.5835 51.3332 42.6668 51.4999C42.7502 51.6666 42.8335 51.8332 43.0002 51.9999C43.3335 52.3333 43.3335 52.9999 43.3335 53.3333C43.3335 53.4999 43.2502 53.7499 43.1668 53.9999C43.0835 54.2499 43.0002 54.4999 43.0002 54.6666Z"
            fill="black"
          />
          <mask
            id="mask0"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="3"
            width="74"
            height="74"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.3335 39.9999C3.3335 60.3332 19.6668 76.6666 40.0002 76.6666C60.3335 76.6666 76.6668 60.3332 76.6668 39.9999C76.6668 19.6666 60.3335 3.33325 40.0002 3.33325C19.6668 3.33325 3.3335 19.6666 3.3335 39.9999ZM10.0002 39.9999C10.0002 23.3333 23.3335 9.99992 40.0002 9.99992C56.6668 9.99992 70.0002 23.3333 70.0002 39.9999C70.0002 56.6666 56.6668 69.9999 40.0002 69.9999C23.3335 69.9999 10.0002 56.6666 10.0002 39.9999ZM43.3335 39.9999V26.6666C43.3335 24.6666 42.0002 23.3333 40.0002 23.3333C38.0002 23.3333 36.6668 24.6666 36.6668 26.6666V39.9999C36.6668 41.9999 38.0002 43.3333 40.0002 43.3333C42.0002 43.3333 43.3335 41.9999 43.3335 39.9999ZM43.0002 54.6666C43.0002 54.9999 42.6668 55.3333 42.3335 55.6666C41.6668 56.3333 41.0002 56.6666 39.6668 56.6666C38.6668 56.6666 38.0002 56.3333 37.3335 55.6666C36.6668 54.9999 36.3335 54.3333 36.3335 53.3333C36.3335 52.9427 36.4479 52.6666 36.5426 52.4378C36.6096 52.2761 36.6668 52.138 36.6668 51.9999C36.6668 51.6666 37.0002 51.3333 37.3335 50.9999C38.3335 49.9999 39.6668 49.6666 41.0002 50.3333C41.1668 50.3333 41.2502 50.4166 41.3335 50.4999C41.4168 50.5832 41.5002 50.6666 41.6668 50.6666C42.0002 50.6666 42.3335 50.9999 42.3335 50.9999C42.5002 51.1666 42.5835 51.3332 42.6668 51.4999C42.7502 51.6666 42.8335 51.8332 43.0002 51.9999C43.3335 52.3333 43.3335 52.9999 43.3335 53.3333C43.3335 53.4999 43.2502 53.7499 43.1668 53.9999C43.0835 54.2499 43.0002 54.4999 43.0002 54.6666Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)">
            <rect
              width="80"
              height="80"
              fill="#FF9F43"
            />
          </g>
        </svg>
        <b-card-title
          class="mb-1 font-weight-bold"
          title-tag="h2"
        >
          {{ title }}
        </b-card-title>
        <b-card-text class="mb-2">
          {{ message }}
        </b-card-text>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mx-1"
          @click="confirm"
        >
          <span>Yes</span>
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 159, 67, .15)'"
          variant="outline-warning"
          class="mx-1"
          @click="closeModal"
        >
          <span>Cancel</span>
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton, BCardTitle, BCardText, VBModal, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BCardTitle,
    BCardText,
    BOverlay,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    toggleModal: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    toggleModal() {
      this.$refs[`confirmation${this.type}`].toggle('#toggle-btn')
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
